import { Stack, Typography } from '@mui/material';

import ALogo from '@/shared/ui/icons/ALogoGradient.svg';

interface ILogoProps {
  isExpanded: boolean;
  isVisible: boolean;
}

const LETTER_GRADIENTS = [
  'linear-gradient(90deg, #ff745d 0%, #ff865f 100%)',
  'linear-gradient(90deg, #fd855d 0%, #ff9360 100%)',
  'linear-gradient(90deg, #fb8c5e 0%, #fd9f61 100%)',
  'linear-gradient(90deg, #ffa160 0%, #ffb062 100%)'
];

/**
 * Компонент логотипа с анимацией
 * @param root0 пропсы
 * @param root0.isExpanded - является ли сайдбар расширенным
 * @param root0.isVisible - виден ли сейчас логотип
 */
export const Logo = ({ isExpanded, isVisible }: ILogoProps) => {
  return (
    <Stack
      direction='row'
      alignItems='center'
      sx={{
        justifyContent: 'center',
        height: 41,
        marginBottom: 1,
        position: 'relative',
        width: '100%',
        '@keyframes slideIn': {
          '0%': {
            opacity: 0,
            transform: 'translateX(20px)'
          },
          '100%': {
            opacity: 1,
            transform: 'translateX(0)'
          }
        }
      }}
    >
      <Stack
        direction='row'
        alignItems='center'
        sx={{
          width: 'auto',
          justifyContent: 'center',
          gap: 1,
          height: '100%'
        }}
      >
        {isVisible && (
          <ALogo
            style={{
              width: 28,
              height: 41,
              opacity: 1,
              transition: 'opacity 0.2s ease-in-out',
              display: 'flex',
              alignItems: 'center'
            }}
          />
        )}
        {isExpanded && isVisible && (
          <Typography
            variant='h4'
            sx={{
              display: 'flex',
              gap: 0.5,
              alignItems: 'center',
              lineHeight: 1,
              height: '100%',
              marginTop: '-2px'
            }}
          >
            {['к', 'т', 'ё', 'р'].map((letter, index) => (
              <span
                key={letter}
                style={{
                  opacity: 0,
                  transform: 'translateX(20px)',
                  animation: isExpanded
                    ? `slideIn 0.3s ease-in-out ${0.1 + index * 0.1}s forwards`
                    : 'none',
                  background: LETTER_GRADIENTS[index],
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                  color: 'transparent',
                  display: 'inline-block'
                }}
              >
                {letter}
              </span>
            ))}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};
